import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface RegionState {
  /** The city the map, Home and the run screen show (remembered between visits). */
  regionId: string | null;
  /** Picked from the city menu: GPS fixes don't move away from it until the run screen opens. Not remembered. */
  pickedByHand: boolean;
  setRegionId: (id: string, byHand?: boolean) => void;
  /** The run screen runs where the runner is: let GPS choose the city again. */
  followGps: () => void;
}

export const useCurrentRegion = create<RegionState>()(
  persist(
    (set) => ({
      regionId: null,
      pickedByHand: false,
      setRegionId: (regionId, byHand = false) => set({ regionId, pickedByHand: byHand }),
      followGps: () => set({ pickedByHand: false }),
    }),
    {
      name: 'rw:region',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ regionId: s.regionId }),
    },
  ),
);
